import { color, radius } from '../theme/tokens.js';

/**
 * Bottom sheet: a dimmed backdrop with a panel anchored to the bottom edge.
 *
 * Clicking the backdrop dismisses; clicks inside the panel are stopped so they
 * don't bubble out and close it. Every modal surface in the app uses this so
 * dismissal behaves identically everywhere.
 *
 * @param {object} props
 * @param {() => void} [props.onDismiss]  Omit to make the sheet non-dismissable.
 * @param {number} [props.zIndex]
 * @param {string | number} [props.maxHeight]
 * @param {boolean} [props.padded]        Adds the standard content padding.
 * @param {React.ReactNode} props.children
 */
export function Sheet({ onDismiss, zIndex = 100, maxHeight = '88vh', padded = true, children }) {
  return (
    <div
      onClick={onDismiss}
      style={{
        position: 'absolute',
        inset: 0,
        background: 'rgba(0,0,0,0.48)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        zIndex,
      }}
    >
      <div
        className="slide-up"
        onClick={(event) => event.stopPropagation()}
        style={{
          background: color.surface,
          borderRadius: `${radius.sheet}px ${radius.sheet}px 0 0`,
          maxHeight,
          display: 'flex',
          flexDirection: 'column',
          padding: padded ? '20px 20px 40px' : 0,
        }}
      >
        <SheetHandle />
        {children}
      </div>
    </div>
  );
}

/** The small grab-handle that signals a sheet can be dismissed. */
export function SheetHandle() {
  return (
    <div
      style={{
        width: 36,
        height: 4,
        background: color.borderStrong,
        borderRadius: 2,
        margin: '0 auto 18px',
        flexShrink: 0,
      }}
    />
  );
}
